// extracted by mini-css-extract-plugin
export default {"root":"mandatory_informations_root__wGqhX","shift":"mandatory_informations_shift__suaLP","contain":"mandatory_informations_contain__5b0-I"};